/* eslint-disable max-len */
import { action } from 'typesafe-actions';
import { StyleUpdateChunk } from '../../types/base';
import { PageActionTypes } from './types';

export const resetFormValuesSuccess = (data: object) => action(PageActionTypes.RESET_FORM_VALUES_SUCCESS, data);

export const formValuesRequest = (data: object) => action(PageActionTypes.SET_FORM_VALUES_REQUEST, data);
export const formValuesSuccess = (data: object) => action(PageActionTypes.SET_FORM_VALUES_SUCCESS, data);

export const uncheckDependentRadioRequest = (data: object) => action(PageActionTypes.UNCHECK_DEPENDENT_RADIO_REQUEST, data);
export const uncheckDependentRadioSuccess = (data: object) => action(PageActionTypes.UNCHECK_DEPENDENT_RADIO_SUCCESS, data);

export const mergeStyleRequest = (data: StyleUpdateChunk[], indexTrigger?: number, context?: any) => action(PageActionTypes.MERGE_STYLE_REQUEST, data, { context, index: indexTrigger });
export const mergeStyleSuccess = (data: object) => action(PageActionTypes.MERGE_STYLE_SUCCESS, data);

export const pageRequest = (data: object, localShimmer?: boolean) => action(PageActionTypes.PAGE_REQUEST, data, localShimmer);
export const pageSuccess = (data: object) => action(PageActionTypes.PAGE_SUCCESS, data);

export const clearForms = () => action(PageActionTypes.CLEAR_FORMS);

export const submitFormRequest = (data: object, localShimmer?: boolean) => action(PageActionTypes.SUBMIT_FORM_REQUEST, data, localShimmer);

export const updateVariableRequest = (data: object) => action(PageActionTypes.UPDATE_VARIABLE_REQUEST, data);
// `replaceArrays: true` switches the reducer merge to REPLACE semantics for arrays ($setVariable
// write path). Omit it (default merge) for Variables-chunk / hydration writes, which rely on
// index-merge for sparse partial arrays.
export const updateVariableSuccess = (data: { data: object; replaceArrays?: boolean }) => action(PageActionTypes.UPDATE_VARIABLE_SUCCESS, data);

export const actionRequest = (data: object, localShimmer?: StyleUpdateChunk[] | boolean) => action(PageActionTypes.ACTION_REQUEST, data, localShimmer);
export const actionSuccess = (data: object) => action(PageActionTypes.ACTION_SUCCESS, data);

export const activateLocalShimmerSuccess = () => action(PageActionTypes.ACTIVATE_LOCAL_SHIMMER_SUCCESS);

